import { ActivatedRoute, Router } from '@angular/router';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppConfig } from '../../../utils/app-config.service';
import { BasePage } from '../../base.page';
import { ClientSignatureType, ContinueTestSignUseCase, GetClientUseCase, SignTestUseCase } from '../../../../core';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { FullClient, Id } from '../../../domain/data';
import { Loader } from '../../../client/helpers/loader';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RepeatTestPage } from '../repeat-test.page';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './repeat-test-sign.page.html',
    styleUrls: ['./repeat-test-sign.page.scss'],
})
export class RepeatTestSignPage extends BasePage implements AfterViewInit, OnInit {
    public ClientSignatureType: typeof ClientSignatureType = ClientSignatureType;

    public client: FullClient;
    public signatureType: ClientSignatureType;
    public isSuitability = false;

    @ViewChild('formLogalty')
    public formLogalty: ElementRef;
    public formLogaltyAction: string = AppConfig.settings.logaltyUrl;
    public formLogaltyXml: string;

    public isClientPortal = environment.portalClient;

    constructor(
        parentEvents: ParentEvents,
        repeatTestPage: RepeatTestPage,
        protected continueTestSignUseCase: ContinueTestSignUseCase,
        protected dialog: MatDialog,
        protected getClientUseCase: GetClientUseCase,
        protected loader: Loader,
        protected localStorage: LocalStorage,
        protected router: Router,
        protected route: ActivatedRoute,
        protected signTestUseCase: SignTestUseCase
    ) {
        super(parentEvents);
        repeatTestPage.hideBackButton();
    }

    ngOnInit() {
        this.getClient();

        this.route.queryParams.subscribe((params) => {
            this.isSuitability = params.suitability === '1';
        });
    }

    protected getClient() {
        if (this.localStorage.clientCode) {
            this.getClientUseCase.bind({ code: Id.fromString(this.localStorage.clientCode) }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.client = transaction.data as FullClient;

                    if (this.isClientPortal) {
                        this.signatureType = ClientSignatureType.IN_PERSON_ELECTRONIC;
                        this.onSubmit();
                    }
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
        } else {
            this.parentEvents.cancel();
        }
    }

    onSubmit() {
        this.signTestUseCase.bind({ client: this.client, signatureType: this.signatureType }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                switch (this.signatureType) {
                    case ClientSignatureType.REMOTE_ELECTRONIC:
                        this.parentEvents.cancel();
                        break;
                    case ClientSignatureType.IN_PERSON_ELECTRONIC:
                        this.continueTestSignUseCase.bind({ client: this.client }).subscribe((transactionSign) => {
                            if (transactionSign.isSuccess) {
                                if (transactionSign.data.xml) {
                                    this.loader.addLoader();

                                    this.localStorage.step = 8;
                                    this.localStorage.write();
                                    this.formLogaltyXml = transactionSign.data.xml;

                                    setTimeout(() => {
                                        this.parentEvents.resizeLoyalty();
                                        (this.formLogalty.nativeElement as HTMLFormElement).submit();
                                    });
                                }
                            } else if (!transactionSign.isAuthError) {
                                this.dialog.open(ErrorDialog, {
                                    data: { text: transaction.error },
                                });
                            }
                        });
                        break;
                    case ClientSignatureType.HANDWRITTEN:
                        this.router.navigateByUrl(MainRoutes.REPEAT_TEST_SIGN_HANDWRITING + (this.isSuitability ? '?suitability=1' : ''));
                        break;
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
        });
    }
}
